import {
  WebSiteSettings,
  webSiteSettingsSchema,
} from "@made-people/grease-structured-data";
import { useStructuredDataSettings } from "./use-structured-data-settings";

export const useGetWebSiteSettings = (): WebSiteSettings | undefined => {
  const structuredDataSettings = useStructuredDataSettings();

  if (!structuredDataSettings) {
    return undefined;
  }

  const webSiteData = structuredDataSettings[0]?.website[0];

  if (!webSiteData) {
    return undefined;
  }

  const parsedWebSiteSettings = webSiteSettingsSchema.safeParse(webSiteData);

  if (!parsedWebSiteSettings.success) {
    console.warn(
      "Failed to parse website settings:",
      parsedWebSiteSettings.error,
    );
    return undefined;
  }

  return parsedWebSiteSettings.data;
};
